// TH
export const locale = {
  TRANSLATOR: {
    SELECT: "Select your language"
  },
  MENU: {
    NEW: "new",
    ACTIONS: "Actions",
    CREATE_POST: "Create New Post",
    PAGES: "Pages",
    FEATURES: "Features",
    APPS: "Apps",
    TITLE: "เมนู",
    DASHBOARD: {
      TITLE: "Dashboard"
    },
    PROFILE: {
      TITLE: "ข้อมูลส่วนตัว"
    },
    LOGOUT: {
      TITLE: "ออกจากระบบ"
    },
    COMPANY_MANAGEMENT: {
      TITLE: "จัดการบริษัท",
      COMPANY: "บริษัท"
    },
    CAMPAIGN_MANAGEMENT: {
      TITLE: "จัดกิจกรรม",
      CAMPAIGN: "กิจกรรม"
    },
    CUSTOM_COLOR: "สีพื้นหลักและปุ่มกด",
    USER_MANAGEMENT: {
      TITLE: "จัดการผู้ใช้งาน",
      USER: "ผู้ใช้งาน",
      MANAGEMENT: "กิจกรรมการจัดการขยะ"
    },
  },
  AUTH: {
    TITLE: "Kepttam",
    GENERAL: {
      OR: "Or",
      SUBMIT_BUTTON: "Submit",
      NO_ACCOUNT: "Don't have an account?",
      SIGNUP_BUTTON: "Sign Up",
      FORGOT_BUTTON: "Forgot Password",
      BACK_BUTTON: "Back",
      PRIVACY: "Privacy",
      LEGAL: "Legal",
      CONTACT: "Contact"
    },
    LOGIN: {
      TITLE: "เข้าสู่ระบบ",
      BUTTON: "ตกลง",
      FORM_INVALID: "กรุณาระบุข้อมูลให้ถูกต้อง"
    },
    FORGOT: {
      TITLE: "ลืมรหัสผ่าน",
      DESC: "ระบุอีเมล์เพื่อเปลี่ยนรหัสผ่าน",
      SUCCESS: "Your account has been successfully reset.",
      FORM_INVALID: "กรุณาระบุข้อมูลให้ถูกต้อง"
    },
    UPDATE_PASSWORD: {
      TITLE: "เปลี่ยนรหัสผ่าน",
      DESC: "ระบบได้ส่งรหัสที่ใช้ในการเปลี่ยนรหัสผ่านไปยังอีเมล์ของคุณแล้ว",
      TIME_ALEAT: "กรุณาเปลี่ยนรหัสผ่านภายใน {second} วินาที",
      TIMEOUT: "รหัสหมดอายุ"
    },
    REGISTER: {
      TITLE: "สมัครสมาชิก",
      DESC: "กรอกรายละเอียดบัญชีของคุณ",
      SUCCESS: "บัญชีของคุณถูกสร้างเรียบร้อยแล้ว.",
      NEW_USER: "สมาชิกใหม่?",
      CREATE_ACCOUNT: "สมัครสมาชิกที่นี่",
      CONFIRM_REGISTER: "คุณได้สมัครสมาชิกเรียบร้อย กรุณาตรวจสอบอีเมลเพื่อทำการยืนยันการสมัครเข้าใช้งานระบบ"
    },
    INPUT: {
      EMAIL: "อีเมล์",
      FULLNAME: "ชื่อ-สกุล",
      PASSWORD: "รหัสผ่าน",
      CONFIRM_PASSWORD: "ยืนยันรหัสผ่าน",
      USERNAME: "ชื่อผู้ใช้งาน",
      CODE: "รหัส",
      NEW_PASSWORD: "รหัสผ่านใหม่",
      CONFIRM_NEW_PASSWORD: "ยืนยันรหัสผ่านใหม่",
      COMPANY_NAME: "ชื่อบริษัท",
      SUBMIT: "ตกลง",
      CANCEL: "ยกเลิก"
    },
    VALIDATION: {
      INVALID: "ข้อมูลไม่ถูกต้อง",
      REQUIRED: "กรุณาระบุข้อมูล",
      MIN_LENGTH: "กรุณาระบุอย่างน้อย {min} อักษร",
      MAX_LENGTH: "กรุณาระบุไม่เกิน {max} อักษร",
      MIN_MAX_LENGTH: "กรุณาระบุย่างน้อย {min} อักษร และไม่เกิน {max} อักษร",
      AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
      NOT_FOUND: "The requested {{name}} is not found",
      INVALID_LOGIN: "The login detail is incorrect",
      REQUIRED_FIELD: "Required field",
      MIN_LENGTH_FIELD: "Minimum field length:",
      MAX_LENGTH_FIELD: "Maximum field length:",
      INVALID_FIELD: "ข้อมูลไม่ถูกต้อง",
      CUSTOM_REQUIRED: "กรุณาระบุ {field}"
    }
  },
  PAGE: {
    DEFAULT: {
      TABLE: {
        SEARCH: "ค้นหา",
        CLEAR: "ลบ",
        NEW: "เพิ่ม",
        DATA_NOT_FOUND: "ไม่พบข้อมูล",
        FIELDS: {
          INDEX: "ลำดับ",
          NAME: "ชื่อ",
          COMPANY: "บริษัท",
          SWITCH: "การใช้งาน",
          USER_TYPE: "ประเภท",
          QUANTITY: "จำนวน",
          POINT: "คะแนน",
          STATUS: {
            TITLE: "สถานะ",
            ACTIVE: "เปิดใช้งาน",
            INACTIVE: "ปิด",
            WAITING_APPROVE: "รอการตรวจสอบ",
            APPROVED: "อนุมัติ",
            UNAPPROVED: "ไม่อนุมัติ",
            ALL: "ทั้งหมด"
          },
          ACTION: {
            TITLE: "จัดการ",
            EDIT: "แก้ไข",
            DELETE: {
              TITLE: "ลบ",
              DESC: "ยืนยันการลบข้อมูล"
            }
          }
        },
        PER_PAGE: "จำนวนข้อมูล"
      },
      FORM: {
        TITLE: "ฟอร์ม",
        FIELDS: {
          NAME: "ชื่อ",
          DETAIL: "รายละเอียด",
          START_DATE: "วันที่เริ่มต้น",
          END_DATE: "วันที่สิ้นสุด",
          IMAGE: "รูปภาพ",
          MAIN_IMAGE: "รูปภาพหลัก",
          BANNER_IMAGE: "รูปภาพแบนเนอร์",
          QUANTITY: "จำนวน/มูลค่า",
          POINT: "คะแนน"
        },
        PLACEHOLDER: {
          CHOOSE_DATE: "เลือกวันที่",
          CHOOSE_IMAGE: "เลือกรูปภาพ"
        },
        OPTIONS: {
          ALL: "ทั้งหมด",
          CUSTOM: "กำหนดเอง"
        },
        BTN_SUBMIT: "ตกลง",
        BTN_OK: "ตกลง",
        BTN_CANCEL: "ยกเลิก",
        BTN_ADD: "เพิ่ม",
        BTN_PREVIEW: "ตัวอย่าง",
        VALIDATION: {
          INVALID: "ข้อมูลไม่ถูกต้อง",
          REQUIRED: "กรุณาระบุข้อมูล",
          MIN_LENGTH: "กรุณาระบุอย่างน้อย {min} อักษร",
          MAX_LENGTH: "กรุณาระบุไม่เกิน {max} อักษร",
          MIN_MAX_LENGTH: "กรุณาระบุย่างน้อย {min} อักษร และไม่เกิน {max} อักษร",
          CHECK_DATA_ALL_TAB: "กรุณากรอกข้อมูลในแต่ละหัวข้อให้ครบ",
          DUPLICATE: "ข้อมูลซ้ำ"
        },
        PS_NOTE: {
          MIN_RECORD: "กรุณาระบุอย่างน้อย 1 อย่าง"
        }
      }
    },
    DASHBOARD: {},
    PROFILE: {
      TABLE: {
        FIELDS: {
          FULLNAME: "ชื่อ - สกุล",
          EMAIL: "อีเมล์"
        }
      },
      FORM: {
        TABS: {
          DATA: "ข้อมูล",
          PASSWORD: "รหัสผ่าน"
        },
        FIELDS: {
          FULLNAME: "ชื่อ - สกุล",
          EMAIL: "อีเมล์",
          PASSWORD: "รหัสผ่าน",
          CONFIRM_PASSWORD: "ยืนยันรหัสผ่าน",
          OLD_PASSWORD: "รหัสผ่านเก่า",
          NEW_PASSWORD: "รหัสผ่านใหม่",
          CONFIRM_NEW_PASSWORD: "ยืนยันรหัสผ่านใหม่"
        }
      }
    },
    COMPANY_MANAGEMENT: {
      TABLE: {
        FIELDS: {
          NAME: "ชื่อ"
        }
      },
      FORM: {
        FIELDS: {
          LOGO_IMAGE: "รูปโลโก้",
          NAME: "ชื่อ"
        }
      }
    },
    COMPANY: {
      FORM: {
        FIELDS: {
          LOGO_IMAGE: "รูปโลโก้"
        }
      }
    },
    CAMPAIGN: {
      TABLE: {
        BUTTON: {
          NEW_CAMPAIGN_RECEIPT: "เพิ่มกิจกรรมใบเสร็จ"
        },
        FIELDS: {
          CAMPAIGN_URL: "URL กิจกรรม",
          START_DATE: "วันที่เริ่ม",
          END_DATE: "วันที่สิ้นสุด",
          CREATED_AT: "วันที่",
          CUSTOMER: "ลูกค้า",
          RECEIPT_TYPE: "ประเภทใบเสร็จ",
          REWARD: "รางวัล",
          POINT: "คะแนน",
          VERIFY_CODE: "รหัสตรวจสอบ",
          REMARK: "หมายเหตุ",
          ANNOUNCE_DATE: "วันที่ประกาศ"
        }
      },
      FORM: {
        FIELDS: {
          LANDING_IMAGE: "รูปภาพหน้าแรก",
          POLICY_IMAGE: "รูปภาพหัวข้อเงื่อนไข",
          POLICY: "เงื่อนไข",
          POLICY_NOT_ACCEPT: "ไม่ยอมรับเงื่อนไข"
        },
        HINT: {
          IS_ACTIVE: "กรุณาอัพเดท LINE LIFF ID เพื่อทำการเปิดใช้งานกิจกรรม",
          BANNER_SCALE: "ขนาดรูปที่เหมาะสมสำหรับแบนเนอร์ 414 x 165"
        },
        MODAL: {
          PRODUCT_TITLE: "ฟอร์มสินค้า",
          REWARD_TITLE: "ฟอร์มรางวัล",
          CUSTOMER_RECEIPT: "ข้อมูลใบเสร็จ"
        },
        CAMPAIGN_RECEIPT: {
          TITLE: "ฟอร์มกิจกรรมใบเสร็จ",
          TAB: {
            GENERAL: "ทั่วไป",
            RECEIPT: "ประเภทใบเสร็จ",
            PRODUCT: "สินค้า",
            REWARD: "รางวัล",
            CUSTOMER: "ผู้เข้าร่วม",
            SEND_MESSAGE: "ส่งข้อความ",
            RECEIPT_REWARD: "แลกรางวัล",
            DASHBOARD: "Dashboard",
            LANDING: "หน้าแรก",
            TERM_AND_CONDITION: "ข้อกำหนดและเงื่อนไข (PDPA)",
            ANNOUNCEMENT: "ประกาศรางวัล"
          },
          TAB_DASHBOARD: {
            FROM: "จาก",
            TO: "ถึง",
            STATUS: "สถานะ",
            SEARCH: "ค้นหา",
            CUSTOMER_PER_HOUR: "จำนวนผู้เล่น 1 ชั่วโมงย้อนหลัง",
            CURRENT_CUSTOME: "จำนวนผู้เล่นในวันนี้",
            CUSTOMER_PER_CAMPAIGN: "จำนวนผู้ส่งใบเสร็จ",
            CAMPAIGN_CUSTOMER_REGISTER: "จำนวนผู้ลงทะเบียนเข้าร่วม",
            CAMPAIGN_LINE_X: "วันที่",
            CAMPAIGN_LINE_Y: "จำนวนผู้เล่น",
            REG_PER_DAY_LINE_X: "วันที่",
            REG_PER_DAY_LINE_Y: "จำนวนผู้สมัคร",
            RECEIPT_TYPE: "ประเภทของใบเสร็จ",
            UNAPPROVED: "สาเหตุที่ไม่อนุมัติใบเสร็จ",
            REWARD: "แลกของรางวัล",
            RECEIPT_REWARD: "เลือกของรางวัล",
            RECEIPT_REWARD_POINT: "สิทธิ์แลกของรางวัล",
            TOTAL: "ทั้งหมด",
            DOWNLOADEXCEL: "ดาวน์โหลด Excel"
          },
          TAB_ANNOUNCE_REWARD: {
            ANNOUNCE_DATE: "วันที่ประกาศ",
            ANNOUNCE_CUSTOMER: "รายชื่อผู้ได้รับรางวัล",
            LABEL_DATE: "เลือกวันที่",
            LABEL_IMAGE: "เลือกรูปภาพ",
            BTN_REMOVE_IMAGE: "ลบรูปภาพ",
            CUSTOMER: "รายชื่อ",
            SEND_MESSAGE: "ส่งข้อความ",
            CUSTOMER_FORM_TITLE: "เพิ่มรายชื่อ",
            CUSTOMER_NAME: "ชื่อผู้ได้รับรางวัล",
            PHONE_NUMBER: "เบอร์โทรศัพท์",
            RECEIPT_CODE: "รหัสใบเสร็จ",
            REWARD: "ระบุรางวัล",
            MESSAGE_DATE: "วันที่ส่ง",
            MESSAGE: "ข้อความ",
            BUTTON_ADD: "บันทึก",
            INPUT_REWARD_INFO: "ระบุรายละเอียดอื่นๆของรางวัลที่ได้รับ",
            INPUT_MESSAGE_INFO: "ข้อความที่กรอกจะแสดงในบรรทัดสุดท้าย",
            LABEL_EX_MESSAGE: "ตัวอย่างข้อความ",
            EX_MESSAGE: "ยินดีด้วย คุณเป็นผู้โชคดีได้รับรางวัลในรอบ xxxxx<br />จากใบเสร็จหมายเลข xxxxx<br />รางวัลที่ได้คือ xxxxx(xxxxx)<br />",
            CONFIRM_SEND_MESSAGE: "คุณต้องการจะส่งข้อความนี้ใช่หรือไม่?",
            INVALID_RECEIPT_CODE: "รหัสใบเสร็จไม่ถูกต้อง",
            CONFIRM_ADD_CUSTOMER: "คุณต้องการจะเพิ่มรายชื่อนี้ใช่หรือไม่?",
            CAMPAIGN_REWARD_NAME: "ของรางวัล"
          },
          ACTIVE_WARNING: 'เมื่อทำการอัพเดท "LINE LIFF ID" แล้ว<br> กิจกรรมนี้จะทำการเปิดใช้งานอัตโนมัติเมื่อถึงวันที่เริ่มต้นที่ตั้งไว้',
          CONFRIM_ENABLE: "คุณต้องการที่ <span style='color:green'>เปิด</span> การใช้งานกิจกรรม ใช่หรือไม่",
          CONFRIM_DISABLE: "คุณต้องการที่ <span style='color:red'>ปิด</span> การใช้งานกิจกรรม ใช่หรือไม่",
          CONFIRM_SUBMIT_WITH_DUPLICATE: "ใบเสร็จนี้มีรหัสตรวจสอบซ้ำกับใบเสร็จที่เคยอนุมัติ คุณต้องการยืนยันที่จะบันทึกข้อมูล ใช่หรือไม่?",
          FIELDS: {
            LINE_MESSAGE_TOKEN: "LINE MESSAGE TOKEN",
            TERM_AND_CONDITION: "เงื่อนไขการเข้าร่วมกิจกรรม",
            CUSTOMER: "ลูกค้า",
            RECEIPT_TYPE: "ประเภทใบเสร็จ",
            REWARD: "รางวัล",
            IS_APPROVE: "การอนุมัติ",
            REASON_NOT_APPROVE: "เหตุผลที่ไม่อนุมัติ",
            UNAPPROVED_REASON_REMARK: "เหตุผลอื่นๆ",
            POINT: "คะแนน",
            VERIFY_CODE: "รหัสตรวจสอบ",
            DATE: "วันที่",
            DATE_QUESTION: "วันที่ส่งคำตอบ",
            QUESTION: "คำถาม",
            ANSWER: "คำตอบ",
            REMARK: "หมายเหตุ",
            TOTAL_SCORE: "คะแนนรวม",
            CODE: "รหัสใบเสร็จ",
            ANSWER_DETAIL: "เฉลย",
            OCR: "ข้อมูลใบเสร็จจาก OCR",
          }
        },
        CAMPAIGN_REWARD: {
          IMAGE: "รูปภาพของรางวัล",
          QUANTITY: "จำนวน",
          POINT: "แต้มที่ใช้แลก",
          DESCRIPTION: "รายละเอียด"
        }
      }
    },
    CUSTOM_COLOR: {
      FORM: {
        FIELDS: {
          BACKGROUND_COLOR: "สีพื้นหลัง",
          BUTTON_COLOR: "สีปุ่มกด",
          BUTTON_TEXT_COLOR: "สีตัวอักษรปุ่มกด"
        }
      }
    },
    CUSTOMER_POINT: {
      TABLE: {
        FIELDS: {
          CUSTOMER: "ลูกค้า",
          POINT: "คะแนน"
        },
        TOTAL_LABEL: "จำนวนทั้งหมด %s คน"
      },
      FORM: {
        FIELDS: {
          MESSAGE: "ข้อความ",
          IMAGE: "รูปภาพ"
        },
        HINT: {
          MAX_FILE: "กรุณากรอกขนาดรูปไม่เกิน 1 MB"
        }
      }
    },
    CAMPAIGN_RECEIPT_REWARD: {
      TABLE: {
        FIELDS: {
          CREATED_AT: "วันที่",
          CUSTOMER: "ลูกค้า",
          REWAED_NAME: "รางวัล"
        }
      },
      FORM: {
        FIELDS: {
          CUSTOMER: "ลูกค้า",
          RECEIPT_REWARD: "รางวัล",
          IS_APPROVE: "การอนุมัติ",
          REMARK: "หมายเหตุ"
        },
        HINT: {
          MAX_FILE: "กรุณากรอกขนาดรูปไม่เกิน 1 MB"
        }
      }
    },
    CAMPAIGN_RECEIPT_MESSAGE: {
      TABLE: {
        FIELDS: {
          CONDITION: "เงื่อนไข",
          IMAGE_PATH: "รูปภาพ",
          MESSAGE: "ข้อความ",
          NUMBER_SEND: "จำนวนผู้รับ (คน)"
        }
      }
    },
    USER: {
      TABLE: {
        FIELDS: {
          FULLNAME: "ชื่อ - สกุล",
          EMAIL: "อีเมล์"
        }
      },
      FORM: {
        TABS: {
          DATA: "ข้อมูล",
          PASSWORD: "รหัสผ่าน"
        },
        FIELDS: {
          FULLNAME: "ชื่อ - สกุล",
          EMAIL: "อีเมล์",
          USER_TYPE: "ประเภทผู้ใช้งาน",
          PHONE_NUMBER: "เบอร์โทร",
          COMPANY: "บริษัท",
          PASSWORD: "รหัสผ่าน",
          CONFIRM_PASSWORD: "ยืนยันรหัสผ่าน",
          OLD_PASSWORD: "รหัสผ่านเก่า",
          NEW_PASSWORD: "รหัสผ่านใหม่",
          CONFIRM_NEW_PASSWORD: "ยืนยันรหัสผ่านใหม่"
        }
      }
    },
  },
  RESPONSE_MESSAGE: {
    ERROR_OCCURRED: "ระบบเกิดข้อผิดพลาด",
    USER_NOT_FOUND: "ไม่พบผู้ใช้งาน",
    EMAIL_DUPLICATE: "อีเมล์นี้มีผู้ใช้งานแล้ว",
    CODE_EXPIRED: "รหัสหมดอายุการใช้งาน",
    SAVE_DATA_SUCCESS: "บันทึกข้อมูลสำเร็จ",
    SAVE_DATA_SUCCESS_LINE_TOKEN_AUTH_FAILE: "<p style='color:red;'>ข้อความสถานะจะไม่ถูกแจ้งเนื่องจาก Line Message Token ไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง</p>",
    SAVE_DATA_FAILURE: "บันทึกข้อมูลไม่สำเร็จ",
    DELETE_DATA_SUCCESS: "ลบข้อมูลสำเร็จ",
    DELETE_DATA_FAILURE: "ลบข้อมูลไม่สำเร็จ",
    DATA_INVALID: "ข้อมูลไม่ถูกต้อง",
    DATA_NOT_FOUND: "ไม่พบข้อมูล",
    DATA_DUPLICATE: "มีข้อมูลนี้แล้ว",
    SYSTEM_ERROR: "ระบบเกิดข้อผิดพลาด",
    COMPANY_NAME_DUPLICATE: "ชื่อบริษัทนี้ถูกใช้งานแล้ว",
    VERIFY_CODE_DUPLICATE: "รหัสตรวจสอบนี้ถูกใช้งานแล้ว",
    CANNOT_SEND_MESSAGE: "ระบบเกิดข้อผิดพลาด ไม่สามารถส่งข้อความได้"
  },
  LOADING: "กำลังโหลด"
};